import React, { useEffect, useState, useContext } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import Loader from "Loader";
import { useNavigate } from "react-router-dom";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Pagination from "@mui/material/Pagination";
import { LanguageContext } from "App";

const PackagesTable = ({ SearchReq, setSearchReq }) => {
  let navigate = useNavigate();
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    {
      Header: translations.createAccountsessionPackageSearchId,
      accessor: "Id",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTablePatient,
      accessor: "Patient",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTablePaidFor,
      accessor: "PaidFor",
      align: "left",
    },
    {
      Header:
        translations.createAccountsessionSingleSessionSearchTableOriginalPrice,
      accessor: "OriginalPrice",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableDiscount,
      accessor: "Discount",
      align: "left",
    },
    {
      Header:
        translations.createAccountsessionSingleSessionSearchTableFinalPrice,
      accessor: "FinalPrice",
      align: "left",
    },
    {
      Header: translations.createAccountsessionSingleSessionSearchTableDetails,
      accessor: "Details",
      align: "center",
    },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);

  const [ResponseData, setResponseData] = useState({});
  const [Response, setResponse] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(
    Object.keys(SearchReq).length > 0 ? SearchReq.pagingParams.pageNumber : 1,
  );
  const [Reload, setReload] = useState(false);
  useEffect(async () => {
    SearchReq.pagingParams.PageNumber = Page;
    setSearchReq({ ...SearchReq });
  }, [Page]);

  const MakeTableRow = (pkg, index) => {
    return {
      Id: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {pkg.id}
        </MDTypography>
      ),
      Patient: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {pkg.getPatient.getUser.name}
        </MDTypography>
      ),
      PaidFor: (
        <input
          id={"pkg.isPaidFor" + pkg.id}
          type="checkbox"
          disabled
          defaultChecked={pkg.isPaidFor}
        />
      ),
      OriginalPrice: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {pkg.originalPrice}
        </MDTypography>
      ),
      Discount: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {Number(pkg.discount).toFixed(1)}%
        </MDTypography>
      ),
      FinalPrice: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {pkg.finalPrice}
        </MDTypography>
      ),
      Details: (
        <MDButton
          onClick={() =>
            navigate("/Packages/Details/", { state: { pkg: pkg } })
          }
        >
          <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
        </MDButton>
      ),
    };
  };
  const GetTableData = async (req) => {
    var res = await SessionsApi.SearchPackages(req);
    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];

      setResponseData(tempResponseData);
      setPaginationPages(res.data.totalPages);
      setIsLoaded(true);
      setReload(false);
    }
  };
  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };
  useEffect(() => {
    setReload(true);
  }, [SearchReq]);
  useEffect(async () => {
    //Get data
    if (!IsLoaded) {
      await GetTableData(SearchReq);
    }
    if (Reload) {
      await GetTableData(SearchReq);
    }
  }, [IsLoaded, Reload]);
  useEffect(() => {
    //Get data
    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    }
  }, [ResponseData]);
  if (!IsLoaded) {
    const loaderType = "balls";
    const loaderColor = "black";
    return <Loader type={loaderType} color={loaderColor} />;
  }
  return (
    <Card>
      <MDBox
        mt={-3}
        py={3}
        px={2}
        sx={{
          backgroundColor: "#3560AD",

          borderTopLeftRadius: "1.1rem",

          borderTopRightRadius: "1.1rem",
        }}
        bgColor="info"
        coloredShadow="info"
      >
        <div class="text-center">
          <MDTypography variant="h6" color="white">
            {translations.PackagesTable}
          </MDTypography>
        </div>
      </MDBox>
      <MDBox p={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
        <div className="text-right mx-3 my-4">
          <Pagination
            count={PaginationPages}
            color="primary"
            onChange={(e, number) => setPage(number)}
            className="float-right"
          />
        </div>
      </MDBox>
    </Card>
  );
};

export default PackagesTable;
